<template>
  <div id="sidebar-wrapper">
    <!-- Sidebar -->
    <ul class="list-group list-group-flush">
      <!--Sistema de Acceso-->
      <li class="list-group-item list-group-item-action sacc">
        <span class="sacc">Sistema de Acceso</span>
        <ul
          class="list-group list-group-flush sacc"
          aria-labelledby="dropdownMenu6"
        >
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'Sistema' }">- Sistema</router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'Comite' }"
              >- Comités de Acceso</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'Instituciones' }"
              >- Instituciones</router-link
            >
          </li>
        </ul>
      </li>
      <!--Admisión Universidades-->
      <li class="list-group-item list-group-item-action sacc">
        <span class="sacc">Admisión Universidades</span>
        <ul
          class="list-group list-group-flush sacc"
          aria-labelledby="dropdownMenu6"
        >
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'AdmisionRegular' }"
              >- Admisión Regular</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'CuposBea' }">
              - Cupos BEA
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'MasMujeresCientificas' }">
              - Cupos Más Mujeres Científicas
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'AdmisionEspecial' }">
              - Admisión Especial
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PaesInvierno' }">
              - PAES Invierno
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PaesRegular' }"
              >- PAES Regular
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PortalPegagias' }">
              - Portal Pedagogías
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PortalExtranjeros' }"
              >- Portal Personas Extranjeras</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'DistincionesTrayectorias' }">
              - Distinciones a las Trayectorias Educativas
            </router-link>
          </li>
        </ul>
      </li>
      <!--Programas de Acceso-->
      <li class="list-group-item list-group-item-action sacc">
        <span class="sacc">Programas de Acceso</span>
        <ul
          class="list-group list-group-flush sacc"
          aria-labelledby="dropdownMenu6"
        >
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PortalPace' }"
              >- Programa PACE</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'ProgramaPedagogias' }"
              >- Programa Acceso a Pedagogías</router-link
            >
          </li>
        </ul>
      </li>
      <!--Beneficios Estudiantiles-->
      <li class="list-group-item list-group-item-action">
        <router-link :to="{ name: 'BeneficiosEstudiantiles' }"
          >Beneficios Estudiantiles</router-link
        >
      </li>
      <!--Preguntas Frecuentes-->
      <li class="list-group-item list-group-item-action sacc">
        <span class="sacc">Preguntas Frecuentes</span>
        <ul
          class="list-group list-group-flush sacc"
          aria-labelledby="dropdownMenu6"
        >
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasAdmisionTP' }"
              >- Admision Técnico Profesional</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasAdmisionU' }"
              >- Admisión Universidades</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasInformacionPAES' }">
              - Información General PAES
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasPedagogias' }">
              - Admisión Pedagogías
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasProgramaPACE' }">
              - Programas PACE
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action">
            <router-link :to="{ name: 'PreguntasSistemaAcceso' }"
              >- Sistema de Acceso</router-link
            >
          </li>
        </ul>
      </li>
    </ul>
    <!-- fin #sidebar-wrapper -->
  </div>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/MenuSidebar.vue